import { FieldArray, FormikProvider, useFormik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import {
    createLocation,
    fetchLocation,
    fetchLocations,
    getLocation,
} from '../../app/reducers/Location/locationSlice';
import PageWithCard from '../../components/infrastructure/PageWithCard';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import FormikTextareaGroup from '../../components/formik/FormikTextareaGroup';
import FormikPhoneInputGroup from '../../components/formik/FormikPhoneInputGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { X } from 'react-feather';
import { useEffect } from 'react';

const AddLocation = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchLocations());
    }, []);

    const formik = useFormik({
        initialValues: {
            name: '',
        },
        onSubmit: (values, { resetForm }) => {
            dispatch(createLocation(values)).then((res) => {
                resetForm();
            });
        },
    });
    return (
        <PageWithCard heading="Add Location">
            {/* {loading ? (
        <ClipLoader />
      ) : ( */}
            <form
                onSubmit={formik.handleSubmit}
                className="flex flex-col gap-4"
            >
                <FormikInputGroup
                    label="Location Name"
                    name="name"
                    required
                    formik={formik}
                />
                <div>
                    <PrimaryButton type="submit">Create</PrimaryButton>
                </div>
            </form>
            {/* )} */}
        </PageWithCard>
    );
};

export default AddLocation;
